export default function Sidebar(handle, {
    buttonHandle,
    menuHandle,
    activeClass,
}) {

    const button = handle.querySelector(buttonHandle);
    const menu = handle.querySelector(menuHandle);
    
    function handleButton() {
        handle.classList.toggle(activeClass);
    }

    button.addEventListener('click', handleButton);
}
